namespace Solovis.UI {
    
    export class ControlRoute {

        public route: string;
        public originalRoute: string;
        public routeData: any;
        public routePath: string;
        public routeParts: string[];

        constructor(options) {
            this.route = options.route ? options.route : null,
            this.originalRoute = options.originalRoute ? options.originalRoute : this;
            this.routeData = options.routeData ? options.routeData : {};

            var fullRouteStr = this.route ? this.route : "";

            var qmarkIndex = fullRouteStr.indexOf("?");
            if (qmarkIndex >= 0) {
                this.routePath = fullRouteStr.substr(0, qmarkIndex);
                var queryStr = fullRouteStr.substring(qmarkIndex + 1, fullRouteStr.length);

                // Parse query string into routeData.
                // TODO: handle character encoding if needed.
                var queryStrParts = queryStr.split("&");
                for (var i = 0; i < queryStrParts.length; i++) {
                    var queryStrPart = queryStrParts[i];
                    var equalsIndex = queryStrPart.indexOf("=");
                    if (equalsIndex >= 0) {
                        var propName = queryStrPart.substr(0, equalsIndex);
                        var propValue = queryStrPart.substring(equalsIndex + 1, queryStrPart.length);
                        this.routeData[propName] = propValue;
                    }
                }
            }
            else {
                this.routePath = fullRouteStr;
            }

            this.routeParts = (this.routePath != "") ? this.routePath.split("/") : null;
        }

        public getRoutePart(index: number): string {
            if (this.routeParts && index < this.routeParts.length) {
                return this.routeParts[index];
            }
            return undefined;
        }

        public getRoutePartCount(): number {
            return this.routeParts ? this.routeParts.length : 0;
        }

        public getSubRoute(startIndex: number): Solovis.UI.ControlRoute {
            var subRoute = null;
            var i = startIndex;
            var partCount = this.getRoutePartCount();

            while (i < partCount) {
                var part = this.routeParts[i];

                if (subRoute == null) {
                    subRoute = part;
                }
                else {
                    subRoute += "/" + part;
                }

                i++;
            }

            return new Solovis.UI.ControlRoute({ route: subRoute, originalRoute: this.originalRoute, routeData: this.routeData });
        }

        public getRouteString(): string {
            var routeStr;
            if (this.routeParts) {
                routeStr = this.routeParts.join("/");
            }
            else {
                routeStr = "";
            }

            if (this.routeData) {
                var queryStr = "";
                for (var i in this.routeData) {
                    if (queryStr != "")
                        queryStr += "&";

                    queryStr += i + "=" + this.routeData[i];
                }

                if (queryStr != "") {
                    routeStr += "?" + queryStr;
                }
            }

            return routeStr;
        }

        public setRouteDataValue(dataKey, dataValue): void {
            if (!this.routeData) {
                this.routeData = {};
            }

            if (dataValue !== null) {
                this.routeData[dataKey] = dataValue;
            }
            else {
                if (this.routeData[dataKey])
                    delete this.routeData[dataKey];
            }
        }

        /**
         * This will replace the hash value of window.location without creating new browser history entry.
         */
        public replaceWindowLocationHashWithThisRoute(): void {          
            var newHashRoute = this.getRouteString();

            var windowLocation = window.location.href;
            var hashIndex = windowLocation.indexOf("#");

            var newWindowLocation;
            if (hashIndex >= 0) {
                newWindowLocation = windowLocation.substr(0, hashIndex) + "#" + newHashRoute;
            }
            else {
                newWindowLocation = windowLocation + "#" + newHashRoute;
            }

            window.location.replace(encodeURI(newWindowLocation));
        }
    }
       
}